import { apiAxiosCMS } from 'services/api';
import { TrainingProps } from 'types/TrainingProps';

export async function getTrainings(
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	handleNotify: any
) {
	setIsLoad(true);
	const listTrainings: TrainingProps[] = await apiAxiosCMS
		.get('/training')
		.then((response) => {
			setIsLoad(false);
			return response?.data || [];
		})
		.catch(() => {
			handleNotify('Erro ao buscar o conteúdo', 'error');

			setIsLoad(false);
			return [];
		});

	return listTrainings;
}

export async function saveOrderReq(
	list: TrainingProps[],
	handleNotify: any,
	showMessageResult = true
) {
	const newList = list.map((item, i) => ({
		id: item.id,
		position: i + 1
	}));

	await apiAxiosCMS
		.patch('/training/sort', { items: newList })
		.then(() => {
			if (showMessageResult) {
				handleNotify('Ordem da lista foi salva com sucesso', 'success');
			}
		})
		.catch(() => {
			handleNotify('Erro ao salvar odem da lista. Tente novamente', 'error');
		});
}
